<a [appStoryblok]="_editable" *ngIf="link" [storyblokLink]="link">{{
  message
}}</a>
<div [appStoryblok]="_editable" *ngIf="!link">{{ message }}</div>
